import { useCallback, useState } from 'react';

export const useDetails = (): [isExpanded: boolean, onClick: () => void] => {
  const [isExpanded, setIsExpanded] = useState(false);

  const onClick = useCallback(() => {
    setIsExpanded(!isExpanded);
  }, [isExpanded]);

  return [isExpanded, onClick];
};
